import { $, $body, debounceResize, bodyGetScrollbarWidth } from './_utility';

/*------------------------------------------------------------------

  Navigation.

-------------------------------------------------------------------*/
function initNavigation() {
  const $item = $(
    '.wp-block-navigation .wp-block-navigation-item.has-child, .wp-block-navigation .wp-block-pages-list__item.has-child'
  );
  const $children = $item.children('.submenu-container, .wp-block-navigation__submenu-container');

  debounceResize(() => {
    $children.each(function () {
      const $thisChildren = $(this);
      const rect = this.getBoundingClientRect();
      const rectLeft = parseInt(rect.left, 10);
      const rectRight = parseInt(rect.right, 10);
      const rectWidth = parseInt(rect.width, 10);
      const isBodyOverflowing = $body[0].clientWidth < window.innerWidth;
      const scrollbarWidth = isBodyOverflowing ? bodyGetScrollbarWidth() : 0;
      const wndW = window.innerWidth - scrollbarWidth;

      if (0 >= wndW - rectRight) {
        $thisChildren.addClass('submenu-drop-left');

        if (wndW - rectRight === rectWidth + 10) {
          $thisChildren.removeClass('submenu-drop-left');
        }
      }

      if (0 >= rectLeft) {
        $thisChildren.addClass('submenu-drop-right');

        if (rectLeft === rectWidth + 10) {
          $thisChildren.removeClass('submenu-drop-right');
        }
      }
    });
  });
}

export { initNavigation };
